export default "__VITE_ASSET__103e00ed__"